import Error from "@components/error/error";

const ArtifactSidebarCannotRead = ({ onClose }: { onClose: () => void }) => {
  return (
    <div className="-mt-3 px-6" aria-label="Error sidebar artifact">
      <div className="pt-2">
        <Error title="You do not have permission to view this content." />
      </div>
    </div>
  );
};

export default ArtifactSidebarCannotRead;
